<template>
  <!-- TODO: Ascunderea de buton sa se faca din prelucrare form -->
  <v-btn color="primary" @click="generatePdf">{{ schema.buttonLabel }}</v-btn>
</template>

<script>
// import { Utils } from "../Utils";
import ApiService from '../APIService.js'

// var utils = new Utils();

export default {
  name: 'PdfGeneratorWidget',
  props: {
    schema: {
      type: Object,
      required: true
    },
    entryId: {
      type: String,
      default: null
    },
    entityId: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      inputValue: this.initialValue || null
    }
  },
  methods: {
    generatePdf() {
      ApiService.downloadPdf(
        this.entityId,
        this.entryId,
        this.schema.pdfTemplateId
      )
        .then((res) => {
          this.forceFileDownload(res, this.entryId + '.pdf')
        })
        .catch((error) => {
          console.log('%cCould not download attachment: ', 'color: #f00')
          console.log(error)
        })
    },
    forceFileDownload(response, downloadFileName) {
      console.log('Download file name: ' + downloadFileName)
      const url = window.URL.createObjectURL(
        new Blob([response.data], { encoding: 'UTF-8' })
      )
      const link = document.createElement('a')
      link.href = url
      link.setAttribute('download', downloadFileName)
      document.body.appendChild(link)
      link.click()
    }
  }
}
</script>
